import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-scan-loader',
  imports: [],
  templateUrl: './image-scan-loader.component.html',
  styleUrl: './image-scan-loader.component.css',
})
export class ImageScanLoaderComponent {
  @Input() imageSrc: string = '';
  @Input() percentageComplete: string = '';

  constructor() {}
}
